<!-- Skip to main content link for accessibility -->
<a href="#main-content" class="skip-link sr-only sr-only-focusable">Saltar al contenido principal</a>

<app-header></app-header>

<main id="main-content" role="main">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>

<!-- Componente de accesibilidad global -->
<app-accessibility></app-accessibility>